import documentsService from '@/services/documents.service'

import { adaptDocumentsApiToPickerResponse } from './documentsPicker.adapters'

import type { DocumentPickerResponse, DocumentsPickerQuery } from './documentsPicker.types'

export async function listFolderPaged(args: DocumentsPickerQuery): Promise<DocumentPickerResponse> {
  const {
    mnemo,
    folderId,
    rootFolderId = 0,
    page = 1,
    pageSize,
    search,
    ignoreTodoFolder,
  } = args

  const pageZeroBased = Math.max(0, page - 1)

  const trimmedSearch = typeof search === 'string' ? search.trim() : ''
  const isSearchMode = trimmedSearch.length > 0

  const queryObject: Record<string, any> = {
    markRecent: true,
    page: pageZeroBased,
    pageSize,
    sortBy: 'name',
    sortDir: 'ASC',
  }

  if (isSearchMode) {
    queryObject['search'] = trimmedSearch
  }

  if (typeof ignoreTodoFolder === 'boolean') {
    queryObject['ignoreTodoFolder'] = ignoreTodoFolder
  }

  const { data: folderData } = await documentsService.getDocumentsPaginated(
    mnemo,
    folderId,
    queryObject,
  )

  let path: any[] | null = null
  const isAtRoot = folderId === rootFolderId

  if (!isAtRoot && !isSearchMode) {
    try {
      const { data: pathData } = await documentsService.getFolderPath(mnemo, folderId)
      path = pathData?.path ?? pathData ?? null
    } catch (e) {
      console.error('Error fetching folder path for Documents picker:', e)
      path = null
    }
  }

  return adaptDocumentsApiToPickerResponse(folderData, path, rootFolderId)
}
